<template>
  <appQuoteNew :propsMode="'new'" :quoteType="'quote'"></appQuoteNew>
</template>
<script>
import { findash } from '../../../config/pluginInit'
import appQuoteNew from '../../../components/quote/quoteNew.vue'

export default {
  name: 'QuoteNew',
  components: {
    appQuoteNew
  },
  mounted() {
    findash.index()
  }
}
</script>
